import _ from 'lodash';
import {apiFetch, apiSearch} from '../utility';

const apiBase = 'bulkInvoice';

const BULK_INVOICE_RESULT = 'accounting/bulkInvoice/SEARCH/';
const BULK_INVOICE_STATUS_CHANGE = 'accounting/bulkInvoice/CHANGE';

const initialState = {
	byStationId : {},
	byStatus : {},
};

export default (state = initialState, action) => {

	if (action.type === BULK_INVOICE_RESULT) {
		if (action.stationId) {
			return {
				...state,
				byStationId: {
					...state.byStationId,
					[action.stationId]: _.map(action.bulkInvoices, 'bulkInvoiceIds'),
				}
			};
		} else if (action.status) {
			return {
				...state,
				byStatus: {
					...state.byStatus,
					[action.status]: _.map(action.bulkInvoices, 'bulkInvoiceId'),
				}
			};
		} else {
			return state;
		}
	} else if (action.type === BULK_INVOICE_STATUS_CHANGE) {
		const {status, bulkInvoiceId} = action.bulkInvoice;

		const pendingIds = _.get(state, ['byStatus', 'pending']);
		const invalidIds = _.get(state, ['byStatus', 'invalid']);
		const issuedIds  = _.get(state, ['byStatus', 'issued']);
		if (!pendingIds || !issuedIds) {
			return state;
		}

		//- New pending invoice. Means we have a new invoice
		if (status === 'pending') {
			const newPendingIds = _.uniq(pendingIds.concat([bulkInvoiceId]));
			return {
				...state,
				byStatus: {
					...state.byStatus,
					pending: newPendingIds,
				}
			};
		}


		//- New invalid invoice. Means we have a new invoice
		if (status === 'invalid') {
			const newInvalidIds = _.uniq(invalidIds.concat([bulkInvoiceId]));
			const newPendingIds = _.filter(pendingIds, id => {
				return id !== bulkInvoiceId;
			});

			return {
				...state,
				byStatus: {
					...state.byStatus,
					pending: newPendingIds,
					invalid: newInvalidIds,
				}
			};
		}

		if (status === 'issued') {
			const newIssuedIds = _.uniq(issuedIds.concat([bulkInvoiceId]));
			const newPendingIds = _.filter(pendingIds, id => {
				return id !== bulkInvoiceId;
			});

			return {
				...state,
				byStatus: {
					...state.byStatus,
					pending: newPendingIds,
					issued: newIssuedIds,
				}
			};
		}
	} else {
		return state;
	}
};

export const search = (p) => {
	const {
		status,
		stationId,
		afterDate,
		callback = _.noop,
	} = p;

	return dispatch => {
		const params = {
			status,
			afterDate,
			stationId
		};

		apiFetch({
			method: `${apiBase}.search`,
			params,
			dispatch,
			callback : (err, r) => {
				if (err) { return callback(err); }

				const bulkInvoices = _.get(r, ['collections', 'bulkInvoiceCollection']);
				dispatch({
					type: BULK_INVOICE_RESULT,
					status,
					stationId,
					bulkInvoices,
				});
				callback();
			}
		});
	};
};

export const get = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const getEmailInfo = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.getEmailInfo`,
			params,
			dispatch,
			callback,
		});
	};
};

export const publicGet = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.public.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.add`,
			listNameToUpdate : 'bulkDeliveryIds',
			params,
			dispatch,
			callback,
			successMessage : `Station invoice created successfully. 
				Click continue to return to the station invoices page.`,
			onSuccessRedirectTo : `/accounting/bulkInvoices`,
		});
	};
};

export const update = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			callback,
		});
	};
};

export const invalidate = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.invalidate`,
			params,
			dispatch,
			callback : (err, r) => {
				if (err) { return callback(err); }
				const bulkInvoice = _.get(r, ['collections', 'bulkInvoiceCollection', 0]);
				dispatch({
					type: BULK_INVOICE_STATUS_CHANGE,
					bulkInvoice,
				});
				callback();
			}
		});
	};
};

export const send = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.send`,
			params,
			dispatch,
			callback : (err, r) => {
				if (err) { return callback(err); }
				const bulkInvoice = _.get(r, ['collections', 'bulkInvoiceCollection', 0]);
				dispatch({
					type: BULK_INVOICE_STATUS_CHANGE,
					bulkInvoice,
				});
				callback();
			}
		});
	};
};

export const searchLogs = ({bulkInvoiceId, callback = _.noop}) => {
	return dispatch => {
		apiSearch({
			method : 'bulkInvoice.log.search',
			base : 'bulkInvoiceLog',
			keyBy : bulkInvoiceId,
			params : {
				bulkInvoiceId,
			},
			dispatch,
			callback,
		});
	};
};

export const advancedSearch = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method : 'bulkInvoice.advancedSearch',
			params,
			dispatch,
			callback
		});
	};
};
